import axiosClient from '../../configs/axios';


class cylinderinventoryreport {
    // Get list 
    async getcylinderinventoryreport(params) {
        try {
            const response = await axiosClient.get(
                `/reports/EmptyCylinderInventory?page=${params.page}&size=${params.size}&searchKey=${params.searchKey}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    



 








   
    
}

export default new cylinderinventoryreport(); 